import { render, staticRenderFns } from "./InterviewHistory.vue?vue&type=template&id=36836a46&scoped=true"
import script from "./InterviewHistory.vue?vue&type=script&lang=js"
export * from "./InterviewHistory.vue?vue&type=script&lang=js"
import style0 from "./InterviewHistory.vue?vue&type=style&index=0&id=36836a46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36836a46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36836a46')) {
      api.createRecord('36836a46', component.options)
    } else {
      api.reload('36836a46', component.options)
    }
    module.hot.accept("./InterviewHistory.vue?vue&type=template&id=36836a46&scoped=true", function () {
      api.rerender('36836a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/RecruitManage/InterviewHistory.vue"
export default component.exports